var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrendingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Trending  Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M9.33568 3.66699H14.0002C14.3421 3.66699 14.6238 3.92435 14.6623 4.25591L14.6668 4.33366V9.00033C14.6668 9.36852 14.3684 9.66699 14.0002 9.66699C13.6583 9.66699 13.3765 9.40963 13.338 9.07807L13.3335 9.00033L13.333 5.94299L8.47157 10.8051C8.2314 11.0452 7.85352 11.0639 7.59198 10.8608L7.52917 10.8055L5.9985 9.27746L2.47311 12.804C2.2128 13.0644 1.79069 13.0644 1.5303 12.8041C1.28994 12.5638 1.27139 12.1857 1.4747 11.9241L1.53015 11.8613L5.52654 7.86365C5.7667 7.62341 6.14462 7.60475 6.40619 7.80779L6.46901 7.86317L7.99976 9.39126L12.3896 5.00033H9.33568C8.99379 5.00033 8.712 4.74297 8.67349 4.41141L8.66901 4.33366C8.66901 3.99177 8.92637 3.70999 9.25793 3.67148L9.33568 3.66699H14.0002H9.33568Z",
    fill: "#27AE60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendingFilled);
export default __webpack_public_path__ + "static/media/arrow_trending_filled.15b9e2c1017eaa7e2f8648ebb379dfca.svg";
export { ForwardRef as ReactComponent };